import { call, put, takeLatest } from "redux-saga/effects";
import { inBangDiemApi } from "../../../api/in-bang-diem/inBangDiemApi";
import { IBangDiemSinhVienSelectRequest } from "../../../model/request/in-bang-diem/IBangDiemSinhVienSelectRequest";
import { eInBangDiemActionIds, IInBangDiemActionTypes } from "../../action-types/in-bang-diem/IInBangDiemActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* inBangDiemSaga(): any {
    yield takeLatest(eInBangDiemActionIds.LOAD_BANG_DIEM_START, loadBangDiemWorker);
}

function* loadBangDiemWorker(action: IInBangDiemActionTypes ) {
    const request  = action.payload as IBangDiemSinhVienSelectRequest;
    const response: IBaseResponse = yield call (inBangDiemApi.SelectBangDiemSinhVien,request);
    debugger
    console.log("🚀 ~ function*loadBangDiemWorker ~ response:", response)
    if (response.is_success) {
      yield put(rootActions.inBangDiem.LOAD_BANG_DIEM_SUCCESS({
        request: request,
        data: toLowerCaseDeep(response.data)
      }))
    } else {
       yield put(rootActions.inBangDiem.LOAD_BANG_DIEM_ERROR({
        request: request,
        data: response.data
      }))
    }
}